import { NameFilterBuilder } from '@/shared/filters/entity-filters/name-filter-builder/name-filter-builder';
import { useFilter } from '@/shared/filters/hooks/use-filter/use-filter';
import { useReadAllResourceGroupsQuery } from '@/shared/redux/api/assets/groups/groups-api';
import { PaginationInput } from '@/shared/types/types.generated';

export const useReadRootGroups = (pagination?: PaginationInput) => {
  const filter = useFilter(new NameFilterBuilder());

  // do not trigger this search, when filter is active
  const result = useReadAllResourceGroupsQuery({ pagination, filter });

  return {
    isLoading: result?.isLoading,
    isFetching: result?.isFetching,
    data: result?.data?.readAllResourceGroups,
  };
};
